import {Inject, Injectable, LOCALE_ID, DOCUMENT} from '@angular/core';
import {filter} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';


const FB_PIXEL_ID: { [key: string]: string } = {
  "fr-x-source": '245089303094872', // for local
  "de-DE": '373363380083992',
  "en-GB": '2297561657153220',
  "en-US": '508597199637008',
  "es-ES": '750724325278527',
  "es-US": '1218756581615449',
  "fr-FR": '245089303094872',
  "it-IT": '336402876944529',
  "pt-BR": '681509141962022',
  "pt-PT": '563195041958369',
  "tr-TR": '2224651187746966' // == tr-DE
};
const PINTEREST_TAG_ID: { [key: string]: string } = {
  "fr-x-source": '2612781938342', // for local
  "de-DE": '2614132711324',
  "en-GB": '2613108939719',
  "en-US": '2613108939719',
  "es-ES": '2613876055187',
  "es-US": '2613876055187',
  "fr-FR": '2612781938342',
  "it-IT": '2613229765318',
  "pt-PT": '2612507801613'
};
const GTM_ID: string = 'GTM-M5F569C';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  private fbInitializedIds: string[] = [];
  private currentFbId?: string;
  private window = this.document.defaultView!;

  constructor(@Inject(LOCALE_ID) public locale: string,
              @Inject(DOCUMENT) private document: Document,
              private router: Router) {
  }


  install() {
    this.installFbScript();
    this.installGTMScript();
    this.pushPinterestId();

    if (this.locale && FB_PIXEL_ID[this.locale]) {
      console.debug(`TrackingService - Init FB with ${this.locale} (${FB_PIXEL_ID[this.locale]})`);
      this.initFbScript(FB_PIXEL_ID[this.locale]);
    } else {
      console.warn(`TrackingService - Cannot init FB (Unknown locale "${this.locale}")`)
    }

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        this.pageView(e.url);
      });
  }

  pageView(url: string) {
    if (this.currentFbId) {
      console.debug('TrackingService - PageView FB', url);
      (this.window as any).fbq('trackSingleCustom', this.currentFbId, 'PageView', {'url': url});
    }
    if ((this.window as any).dataLayer) {
      console.debug('TrackingService - PageView GTM', url);
      ((this.window as any).dataLayer as any[]).push({'event': 'PageView', 'url': url});
    }
  }

  gameEvent(eventName: string, data = {}) {
    if (this.currentFbId) {
      console.debug('TrackingService - GameEvent FB', eventName);
      (window as any).fbq('trackSingleCustom', this.currentFbId, 'GameEvent', {
        ...{'event_name': eventName}, ...data
      });
    }
    if ((window as any).dataLayer) {
      console.debug('TrackingService - GameEvent GTM', eventName);
      ((window as any).dataLayer as any[]).push({...{'event': 'GameEvent', 'event_name': eventName}, ...data});
    }
  }

  private installFbScript() {
    console.debug('TrackingService - Install FB Script');
    // @ts-ignore
    !function(f: any, b, e, v, n: any, t: any, s: any){
      if(f.fbq) return;
      n=f.fbq=function(){n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
      if(!f._fbq) f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
      t=b.createElement(e);
      t.async=!0;t.src=v;
      // t.type = 'script/partytown';
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    }(this.window as any, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }

  private installGTMScript() {
    console.debug('TrackingService - Install GTM Script');
    (function(w: any, d, s, l, i){
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      const f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      (j as HTMLScriptElement).async = true;
      // (j as HTMLScriptElement).type = 'script/partytown';
      (j as HTMLScriptElement).src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode?.insertBefore(j, f);
    })(this.window, document, 'script', 'dataLayer', GTM_ID);
  }

  private pushPinterestId() {
    const tagId = this.locale ? PINTEREST_TAG_ID[this.locale] : undefined;
    if (!tagId) {
      console.warn(`TrackingService - Cannot push Pinterest ID (Unknown locale "${this.locale}")`);
      return;
    }
    console.debug(`TrackingService - Push Pinterest ID with ${this.locale} (${tagId})`);
    ((this.window as any).dataLayer as any[]).push({'pinterest_id': tagId});
  }

  private initFbScript(pixelId: string) {
    this.currentFbId = pixelId;
    if (!this.fbInitializedIds.includes(this.currentFbId)) {
      console.debug(`TrackingService - Init FB (${this.currentFbId})`)
      // only init() if not previously done
      this.fbInitializedIds.push(this.currentFbId);
      (this.window as any).fbq('init', this.currentFbId);
    }
    // this.pageView();
  }
}
